import { createContext, useContext } from "react";

export const CustomerContext = createContext(null); 

export const useCustomer = () => {
  const context = useContext(CustomerContext);
  if (!context) {
    throw new Error("useCustomer must be used within a CustomerContext.Provider");
  }
  return context;
};
